import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { ThemeContext } from '../../ThemeContext';
import logoWhite from '../../assets/images/payswitch-logo-white.png';
import logoBlack from '../../assets/images/payswitch-logo-black.png';
import Footer from "../footer/Footer";

class NotFoundLayout extends Component {
    static contextType = ThemeContext;

    render() {
        const { isDark, toggleTheme } = this.context;

        return (
            <div className={`ps-nfl-shell${isDark ? ' dark' : ''}`}>
                <div className="ps-ambient-bg" />

                <header className="ps-header" style={{ position: 'relative', zIndex: 10 }}>
                    <div className="ps-logo">
                        <img src={isDark ? logoWhite : logoBlack} alt="Payswitch" />
                    </div>
                    <button className="ps-theme-toggle" onClick={toggleTheme}
                        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
                        {isDark ? (
                            <svg className="sun-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="5"/>
                                <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                                <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                            </svg>
                        ) : (
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                            </svg>
                        )}
                    </button>
                </header>

                <div className="ps-nfl-main">
                    {this.props.component}
                </div>

                <Footer />
            </div>
        );
    }
}

export default withRouter(NotFoundLayout);
